import { render, staticRenderFns } from "./PaginaNaoEncontrada.vue?vue&type=template&id=b24d90e2&scoped=true&"
import script from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js&"
export * from "./PaginaNaoEncontrada.vue?vue&type=script&lang=js&"
import style0 from "./PaginaNaoEncontrada.vue?vue&type=style&index=0&id=b24d90e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24d90e2",
  null
  
)

export default component.exports